import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import { SocketProvider } from './context/SocketContext';

// Pages
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import ClockPage from './pages/ClockPage';
import MyAttendance from './pages/MyAttendance';
import Profile from './pages/Profile';
import MyLeaves from './pages/MyLeaves';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminEmployees from './pages/admin/AdminEmployees';
import AdminTeams from './pages/admin/AdminTeams';
import AdminReports from './pages/admin/AdminReports';
import AdminLeaves from './pages/admin/AdminLeaves';
import AdminSettings from './pages/admin/AdminSettings';
import AdminLocations from "./pages/admin/AdminLocations";
import AdminMenu from "./pages/admin/AdminMenu";
import KioskPage from './pages/KioskPage';
import Layout from './components/Layout';

const PrivateRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center h-screen"><div className="spinner" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};

export default function App() {
  return (
    <AuthProvider>
      <SocketProvider>
        <BrowserRouter>
          <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/kiosk" element={<KioskPage />} />
            <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="clock" element={<ClockPage />} />
              <Route path="my-attendance" element={<MyAttendance />} />
              <Route path="leaves" element={<MyLeaves />} />
              <Route path="profile" element={<Profile />} />
              <Route path="admin" element={<PrivateRoute roles={["admin", "manager"]}><AdminDashboard /></PrivateRoute>} />
              <Route path="admin/menu" element={<PrivateRoute roles={["admin", "manager"]}><AdminMenu /></PrivateRoute>} />
              <Route path="admin/employees" element={<PrivateRoute roles={['admin']}><AdminEmployees /></PrivateRoute>} />
              <Route path="admin/teams" element={<PrivateRoute roles={['admin', 'manager']}><AdminTeams /></PrivateRoute>} />
              <Route path="admin/reports" element={<PrivateRoute roles={['admin', 'manager']}><AdminReports /></PrivateRoute>} />
              <Route path="admin/leaves" element={<PrivateRoute roles={['admin', 'manager']}><AdminLeaves /></PrivateRoute>} />
              <Route path="admin/locations" element={<PrivateRoute roles={['admin']}><AdminLocations /></PrivateRoute>} />
              <Route path="admin/settings" element={<PrivateRoute roles={['admin']}><AdminSettings /></PrivateRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </SocketProvider>
    </AuthProvider>
  );
}
